module.exports = __webpack_public_path__ + "img/0.cda3790c.jpg";